import { cimAxiosClient } from '@/lib';
import { ApiResponse } from '@/types';
import { withLogger } from '@/utils';

import { cimAPIUrls } from '../data';

type XPMConnectionDetails = {
  id: string;
  authEventId: string;
  tenantId: string;
  tenantType: string;
  tenantName: string;
  createdDateUtc: string;
  updatedDateUtc: string;
};

type XPMConnectionData = {
  connected: boolean;
  access_token: string;
  details: XPMConnectionDetails;
};

type XPMConnectionResponse = {
  success: boolean;
  data: XPMConnectionData;
  message: string;
};

export type GetXPMCheckConnection = {
  return: XPMConnectionResponse;
};

export const getXPMCheckConnection = withLogger(
  async (): Promise<XPMConnectionResponse> => {
    const response = await cimAxiosClient.get<
      ApiResponse<XPMConnectionResponse>
    >(cimAPIUrls.xpmCheckConnection);

    return response.data.data;
  },
);
